import { RankIcon } from 'src/components/insights/icons/rank'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/rank-over-time.png'

const BrandRankOverTime = dynamic(() => import('src/components/insights/rank/rank-over-time/by-brand-for-report'), {
  ssr: false,
})

const CategoryRankOverTime = dynamic(
  () => import('src/components/insights/rank/rank-over-time/by-category-for-report'),
  {
    ssr: false,
  }
)

export const BrandRankOverTimeWidget: InsightBuilderWidget = {
  id: 'rank-over-time',
  name: 'Rank Over Time (Percentile Rank)',
  type: 'Rank',
  icon: RankIcon,
  component: BrandRankOverTime,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}

export const CategoryRankOverTimeWidget: InsightBuilderWidget = {
  id: 'category-rank-over-time',
  name: 'Rank Over Time Within Categories',
  type: 'Category Rank',
  icon: RankIcon,
  component: CategoryRankOverTime,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
